const selectors = {
  openEmailCaptureButton: "button.email-capture__open",
  closeBottomBannerButton: "button.email-capture__close",
};
export default selectors;
